import {v1_PostsOnlineStatus_select_column} from '../../generated/types';

const PostOnlineStatus = {
    ...v1_PostsOnlineStatus_select_column,
    res: 'v1_PostsOnlineStatus',
    comp: {},
    rel: {},
};

export default PostOnlineStatus;
